import {
    ChangeDetectionStrategy,
    Component,
    ElementRef,
    EventEmitter,
    HostListener,
    Input,
    Output,
    ViewChild,
} from '@angular/core';

import { CorePlatformService } from '@core/infrastructure/platform/platform.service';

@Component({
    selector: 'slide-elements',
    templateUrl: './slide-elements.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
})
export class SlideElementsComponent {
    @ViewChild('divContainer') public divContainer: ElementRef;

    @Input() public dark: boolean;

    @Input() public nativeScroll = false;

    @Input() public hideScroll = false;

    @Input() public customScroll = false;

    @Output() public readonly clickActive = new EventEmitter<boolean>();

    private isDown = false;

    private startX: number;

    public scrollLeft: number;

    public opacityGrandientStart = 0;

    public opacityGrandientEnd = 1;

    constructor(private readonly platform: CorePlatformService) {}

    public scrollBy(scrollTo: number) {
        this.divContainer.nativeElement.scrollBy({
            top: 0,
            left: scrollTo,
            behavior: 'smooth',
        });
    }

    public scrollingStop(): void {
        if (this.platform.isBrowser()) {
            if (this.isDown) {
                setTimeout(() => {
                    this.clickActive.emit(true);
                }, 100);
            }

            this.isDown = false;
        }
    }

    @HostListener('mousedown', ['$event'])
    public scrolling(e: MouseEvent): void {
        document.addEventListener('mousemove', this.mouseMove.bind(this));
        document.addEventListener('mouseup', this.scrollingStop.bind(this));

        this.isDown = true;

        // Se calcula la posición inicial del mouse relativa al contenedor
        const { pageX } = e;
        this.startX = pageX - this.divContainer.nativeElement.offsetLeft;

        // Se almacena la posición de desplazamiento actual del contenedor
        this.scrollLeft = this.divContainer.nativeElement.scrollLeft;
    }

    public mouseMove(e: MouseEvent): void {
        // Si no se ha iniciado el arrastre, sal del método
        if (!this.isDown) return;

        e.preventDefault();
        e.stopPropagation();

        // Obtiene la posición X del mouse relativa al contenedor
        const { pageX } = e;
        const x = pageX - this.divContainer.nativeElement.offsetLeft;

        // Calcula el desplazamiento basado en la diferencia entre la posición X inicial y la actual
        const walk = x - this.startX; // scroll-fast

        // Aplica el desplazamiento al contenedor
        this.divContainer.nativeElement.scrollLeft = this.scrollLeft - walk;
    }

    public onScroll($event: Event) {
        this.clickActive.emit(false);

        const target = $event.target as HTMLElement;
        const { scrollLeft, scrollWidth, clientWidth } = target;

        const scrollLeftAbs = Math.abs(scrollLeft);
        const threshold = 16; // Umbral para la opacidad

        // Calcula la distancia al final del contenedor
        const distanceToEnd = scrollWidth - (scrollLeftAbs + clientWidth);

        // Calcula la opacidad para el inicio del gradiente
        const opacityStart = scrollLeftAbs <= threshold ? scrollLeftAbs / threshold : 1;

        // Calcula la opacidad para el final del gradiente
        const opacityEnd = distanceToEnd <= threshold ? distanceToEnd / threshold : 1;

        // Asigna los valores de opacidad
        this.opacityGrandientStart = opacityStart;
        this.opacityGrandientEnd = opacityEnd;
    }
}
